<template>
  <div>
    <div class="toolbar">
      <div class="toolbar-item">
        <span class="toolbar-label">调整优先级</span>
        <el-popover placement="right" title="拖拽条件调整优先级顺序" width="250" trigger="click">
          <draggable style="width: 100%; min-height:25px" :list="prioritySortList" group="from" :options="sortOption" :move="checkMove">
            <div :class="{'drag-no-choose': true, 'theme-text': cd.id === selectedNode.id, 'drag-locked': index === prioritySortList.length - 1}"
                 v-for="(cd, index) in prioritySortList" :key="`cd-${index}`">
              <ellipsis hover-tip :content="cd.name"/>
              <div>优先级 {{ index + 1 }}</div>
            </div>
          </draggable>
          <el-button icon="el-icon-sort" size="small" slot="reference">第{{ nowNodeLeave + 1 }}级</el-button>
        </el-popover>
      </div>
      <div class="toolbar-item">
        <span class="toolbar-label">条件组关系</span>
        <el-switch v-model="config.groupsType"
                   active-value="AND" inactive-value="OR"
                   active-text="且" inactive-text="或">
        </el-switch>
      </div>
    </div>
    <div class="add-group-bar">
      <el-button type="primary" size="mini" icon="el-icon-plus" round @click="addConditionGroup">
        添加条件组
      </el-button>
      <span class="item-desc">只有必填选项才能作为审批条件</span>
    </div>
    <group-item/>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import GroupItem from './ConditionGroupItemConfig'

export default {
  name: 'ConditionNodeConfig',
  inject: ['$workflow'],
  components: {Draggable, GroupItem},
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    selectedNode () {
      return this.$workflow.selectedNode
    },
    select () {
      return this.config.assignedUser || []
    },
    nowNodeLeave () {
      return this.prioritySortList.indexOf(this.selectedNode)
    },
    // 条件节点
    prioritySortList () {
      let node = this.$workflow.nodeMap.get(this.selectedNode.parentId)
      if (node) {
        return node.branches || []
      }
      return []
    }
  },
  data () {
    return {
      sortOption: {
        animation: 300,
        chosenClass: 'choose',
        scroll: true,
        sort: true
      }
    }
  },
  methods: {
    addConditionGroup () {
      this.config.groups.push({
        cids: [],
        groupType: 'OR',
        conditions: []
      })
    },
    checkMove (evt) {
      const list = this.prioritySortList
      const lastIndex = list.length - 1
      // 禁止拖动最后一项
      if (evt.draggedContext.index === lastIndex) {
        return false
      }
      // 禁止放到最后位置
      if (evt.draggedContext.futureIndex === lastIndex) {
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.toolbar-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.toolbar-label {
  font-size: 13px;
  color: #606266;
  white-space: nowrap;
}

.add-group-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.choose {
  border-radius: 5px;
  margin-top: 2px;
  background: #f4f4f4;
}

.drag-locked {
  cursor: not-allowed !important;
  pointer-events: none;
  opacity: 0.6;
}

.drag-no-choose {
  cursor: move;
  background: #f8f8f8;
  border-radius: 5px;
  margin: 5px 0;
  height: 30px;
  line-height: 20px;
  padding: 5px 10px;
  border: 1px solid #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  div{
    display: inline-block;
    font-size: small !important;
  }

  div:nth-child(2) {
    margin-left: 5px;
    white-space: nowrap;
  }
}
</style>
